"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ModalAuto = void 0;
var react_1 = __importStar(require("react"));
var Button_1 = require("../../Button");
var HFlow_1 = require("../../HFlow");
var Modal_1 = require("../Modal");
var ModalBody_1 = require("../ModalBody");
var ModalFooter_1 = require("../ModalFooter");
exports.ModalAuto = react_1.memo(function (props) {
    var actions = props.actions, size = props.size, render = props.render, dispose = props.dispose, onClose = props.onClose, closeOnBackdropClick = props.closeOnBackdropClick, rest = __rest(props, ["actions", "size", "render", "dispose", "onClose", "closeOnBackdropClick"]);
    var _a = react_1.useState(false), isOpen = _a[0], setIsOpen = _a[1];
    react_1.useEffect(function () {
        setIsOpen(true);
    }, []);
    var close = function () {
        onClose && onClose();
        setIsOpen(false);
        // Dispose with timeout to preserve closing transition
        setTimeout(dispose, 500);
    };
    var handleAction = function (action) { return function (e) {
        action.onClick && action.onClick(e);
        close();
    }; };
    return (react_1.default.createElement(Modal_1.Modal, __assign({ open: isOpen, size: size, onClose: close, closeOnBackdropClick: closeOnBackdropClick }, rest),
        react_1.default.createElement(ModalBody_1.ModalBody, null, render({ close: close })),
        actions && (react_1.default.createElement(ModalFooter_1.ModalFooter, null,
            react_1.default.createElement(HFlow_1.HFlow, { justifyContent: 'flex-end' }, actions.map(function (action, idx) {
                var label = action.label, rest = __rest(action, ["label"]);
                return (react_1.default.createElement(Button_1.Button, __assign({ key: idx, style: { minWidth: 144 } }, rest, { onClick: handleAction(action) }), label));
            }))))));
});
//# sourceMappingURL=ModalAuto.js.map